const CDN = "https://static.prod-images.emergentagent.com/jobs/0bba5c91-2ca2-4419-be41-ba28f94a5ec4/images";

export const OWNER_PHOTO = "https://customer-assets.emergentagent.com/job_montana-trails/artifacts/gn8fi6ln_IMG_9715.jpeg";

export const IMAGES = {
  hero: `${CDN}/37660bfae8366e7293615467020351a0da43f2c312abd566a20a25b3d6a01839.png`,
  showcaseTrail: `${CDN}/cf63e7303c689264b13bb6e6e92e1a80132cee72e0fec0a3aa661a5f8f1083ae.png`,
  showcaseFir: `${CDN}/6142738b267867752241430f3edc39d0bfc627a7443246baa79adbba8c383dc7.png`,
  showcaseLake: `${CDN}/8c45c8e8ae785e21e6e8295b86699d67b46b1eb6ebc2c6a169f9b86a5819bce2.png`,
};

export const GALLERY = [
  {
    url: `${CDN}/eb4fe489546cb878d7326993a27b823bd8c2309e51be37b6e91e1482ab724ed6.png`,
    caption: "Packed-dirt singletrack winding through green timber",
  },
  {
    url: `${CDN}/fd1580633ac89b5ddc881653b3bd8c63ad6cd2ea717646fe401aa371625883dc.png`,
    caption: "Dirt trail benched into a forested hillside",
  },
  {
    url: `${CDN}/1b9e0ea8a40941d5e51816de03aeb42f63b367492b2fce5763310712df6c61b3.png`,
    caption: "Wide smooth path curving through bright green forest",
  },
  {
    url: `${CDN}/cf63e7303c689264b13bb6e6e92e1a80132cee72e0fec0a3aa661a5f8f1083ae.png`,
    caption: "A clean dirt singletrack curving through the timber",
  },
  {
    url: `${CDN}/5cbd196377857d54ff5bca4ea5aa6624c7fccfb7bb96735f0f109c6539da923e.png`,
    caption: "Hand-finished tread and stonework up close",
  },
  {
    url: `${CDN}/8c45c8e8ae785e21e6e8295b86699d67b46b1eb6ebc2c6a169f9b86a5819bce2.png`,
    caption: "A new trail winding down to the lake",
  },
];

export const SERVICES = [
  {
    title: "Trail Design & Layout",
    body: "We walk your land and flag sustainable, scenic lines that follow the natural contours of the terrain. Gentle grades, smart drainage, and routes that open up the best of your property.",
  },
  {
    title: "Dirt & Mulch Trails",
    body: "Clean, natural-surface trails built to last. Whether you want a firm packed-dirt tread or a soft mulched path through the woods, we shape it smooth so it feels like it has always been there.",
  },
  {
    title: "Small-Rock & Stone Retaining",
    body: "Simple, hand-stacked rock retaining along the lower side of banks to hold the tread, manage runoff, and keep your trail solid season after season.",
  },
  {
    title: "Maintenance & Restoration",
    body: "Brushing, re-grading, drainage repair, and tread restoration to bring tired or overgrown trails back to life and keep new ones in top shape.",
  },
];

export const OTHER_SERVICES = [
  {
    title: "General Building Construction",
    body: "From custom homes and shops to outbuildings — framing, structures, and finish work built to last.",
    url: `${CDN}/cf9f18f4f6705e7098ae06f208d5b59383d382d50af49e186aa4d51530c861eb.png`,
  },
  {
    title: "Driveways & Foundations",
    body: "Gravel and dirt driveways, site prep, excavation, grading, and foundation pads — leveled clean and built to drain.",
    url: `${CDN}/29ebdc7f066fb04055e77ede928954893d448b1fcb23f5e76f7d9466d29f1af5.png`,
  },
  {
    title: "Landscape & Design",
    body: "Grading, rock retaining walls, stone edging, rock beds, and planting to shape and finish the land around your home.",
    url: `${CDN}/c650bb5aebf90b0e815a532120242cb928cebfa3acfbdab8d6a524a2beaf6d3f.png`,
  },
];

export const BUILD_LIST = [
  "Custom matched sheds",
  "Pole barns",
  "Shops",
  "Custom homes",
];

